import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { EMPTY, take } from 'rxjs';

import { InsurancePackageService } from '@admin/core/services/insurance-package.service';

import { InsurancePackage } from '@lib/core/models/insurance-package.interface';

export const InsurancePackageResolver: ResolveFn<InsurancePackage> = (route: ActivatedRouteSnapshot) => {
  const packagesService = inject(InsurancePackageService);
  const packageId = route.paramMap.get('packageId');

  if (!packageId) return EMPTY;

  return packagesService.getInsurancePackageById(packageId).pipe(take(1));
};
